import { Title } from "@mantine/core";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";

// reactstrap components
import { Col, Row } from "reactstrap";

function GreetingText() {
	const { user: userData } = useSelector((state) => state.auth);
	const currentUser = userData.user;
	const greetings = useMemo(() => {
		var currentHour = moment().format("HH");
		if (currentHour >= 5 && currentHour < 12) {
			return "Good morning";
		} else if (currentHour >= 12 && currentHour < 17) {
			return "Good afternoon";
		} else if (currentHour >= 17 && currentHour < 5) {
			return "Good evening";
		} else {
			return "Hello";
		}
	}, []);

	return (
		<Title order={2}>
			{greetings},{" "}
			<span className='text-capitalize text-fca-green'>
				{currentUser.learnermaster_name.toLowerCase()}
			</span>
		</Title>
	);
}

export default GreetingText;
